export default "__VITE_ASSET__40de7c1e__"